import axios from "axios";

const api = axios.create({
    baseURL: "https://srt.fsymbols.in/",
    timeout: 5000,
});

export default api;
